import request from '@/utils/request'

// 打印记录
export const home = data => {
  return request({
    url: '/api/home/home',
    method: 'get',
    params: data
  })
}

export const getMcToken = data => {
  return request({
    url: '/api/home/mc-token',
    method: 'get',
    params: data
  })
}

// 首页 - 公告
// export const homeArticle = data => {
//   return request({
//     url: '/api/v2/home/article',
//     method: 'get',
//     params: data
//   })
// }
